<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Crea nuova preferenza amministratore
  </span>
  <ng-template #editHeader>
    Modifica preferenza amministratore
  </ng-template>
</h4>
<form *ngIf="form" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">

  <mat-form-field>
    <mat-label>Amministratore</mat-label>
    <amministratore-picker formControlName="altro_soggetto"></amministratore-picker>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Compagnia</mat-label>
    <compagnia-picker formControlName="compagnia"></compagnia-picker>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Incaricato</mat-label>
    <user-picker formControlName="incaricato"></user-picker>
  </mat-form-field>
</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>
